import { useState, useEffect } from 'react';
import { formFeedsApi, FormFeed } from '../../../services/formFeedsApi';
import toast from 'react-hot-toast';

export const useFormFeeds = (page: number = 1, limit: number = 15) => {
  const [feeds, setFeeds] = useState<FormFeed[]>([]);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  const fetchFeeds = async () => {
    try {
      setLoading(true);
      const response = await formFeedsApi.list({ page, limit });
      setFeeds(response.data);
      setTotalPages(response.last_page || 1);
      setTotal(response.total || 0);
    } catch (error: any) {
      toast.error(error.response?.data?.message || 'Failed to fetch feeds');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeeds();
  }, [page, limit]);

  const deleteFeed = async (id: number) => {
    try {
      await formFeedsApi.delete(id);
      toast.success('Feed deleted successfully');
      fetchFeeds();
    } catch (error: any) {
      toast.error(error.response?.data?.message || 'Failed to delete feed');
    }
  };

  const syncSubmission = async (feedId: number, submissionId: number) => {
    try {
      await formFeedsApi.syncSubmission(feedId, submissionId);
      toast.success('Submission synced successfully');
    } catch (error: any) {
      toast.error(error.response?.data?.message || 'Failed to sync submission');
    }
  };

  return {
    feeds,
    loading,
    totalPages,
    total,
    fetchFeeds,
    deleteFeed,
    syncSubmission,
  };
};
